import React, { useEffect } from 'react';
import { BsCheck } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Flex, HStack, Icon, Image, Text, VStack } from '@chakra-ui/react';

import ButtonGroup from '../../../../components/Modal/ModalButtonGroups/ButtonGroup';
import { getCompanyIntegrations, selectCompanyId, selectCompanyIntegrations } from '../../../../redux/modules/company';
import { hideModal, showModal } from '../../../../redux/modules/modal';
import colors from '../../../../styles/theme/foundation/colors';
import shadows from '../../../../styles/theme/foundation/shadows';

const Integrations = () => {
  const dispatch = useDispatch();
  const integrations = useSelector(selectCompanyIntegrations);
  const companyId = useSelector(selectCompanyId);

  useEffect(() => {
    if (companyId) {
      dispatch(getCompanyIntegrations(companyId));
    }
  }, [companyId]); // eslint-disable-line

  const handleClick = integration => {
    if (integration.name === 'private') return;

    dispatch(showModal(
      () => (
        <div>
          <Text size="lg">
            Continue to
            {' '}
            {integration.displayName}
            {' '}
            integration setup?
          </Text>
          <Text size="md">
            (You will be redirected)
          </Text>
        </div>
      ),
      {
        title: integration.displayName,
        size: 'md',
        onClose: () => dispatch(hideModal()),
        buttons: {
          component: ButtonGroup,
          primaryButtonOptions: {
            label: 'Continue',
            onClick: () => window.location.replace(
              `${integration.url}?company_id=${companyId}&return_url=${window.location.href}`
            )
          },
          componentOptions: { justify: 'center' },
          size: 'md',
          width: 'auto',
          dataAnalyticsId: `${integration.name}-click`
        }
      }
    ));
  };

  return (
    <VStack alignItems="flex-start" spacing={4}>
      <HStack>
        {integrations.filter(i => i.name !== 'private').map(integration => (
          <Button
            _hover={{ boxShade: shadows.hover }}
            bg="white"
            height="auto"
            onClick={() => handleClick(integration)}
          >
            <Box h={200} position="relative" w={300}>
              <Image
                alt={integration.name}
                maxHeight="100%"
                objectFit="contain"
                src={integration.imageUrl}
                width="100%"
              />
              {integration.active && (
                <Icon
                  as={BsCheck}
                  boxSize="48px"
                  color={colors.success.primary[600]}
                  position="absolute"
                  right="10px"
                  size="48px"
                  top="10px"
                />
              )}
            </Box>
          </Button>
        ))}
      </HStack>
      <HStack alignItems="center" justifyContent="flex-start" mt={4}>
        {integrations.filter(i => i.name === 'private').map(integration => (
          <Button
            _hover={{ boxShade: shadows.hover }}
            bg="white"
            borderRadius={2}
            height="auto"
            variant="textBlack"
            onClick={() => handleClick(integration)}
          >
            <Flex alignItems="center" h={200} justifyContent="center" position="relative" w={300}>
              {integration.active && (
                <Icon
                  as={BsCheck}
                  boxSize="48px"
                  color={colors.success.primary[600]}
                  position="absolute"
                  right="10px"
                  size="48px"
                  top="10px"
                />
              )}
              <Text>Private Application</Text>
            </Flex>
          </Button>
        ))}
      </HStack>
    </VStack>
  );
};

Integrations.propTypes = {};

export default Integrations;
